module.exports = __webpack_public_path__ + "img/icon_img12.1f6d00d7.png";